import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IDropdownModel } from "common/models/IDropdownModel";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { materialTypeView } from "../types/materialTypeView";
import {
  IMaterialType,
  IMaterialTypeGridFilter,
  IMaterialTypeGridModel,
} from "./types";

export const materialType = createQueryKeys("materialType", {
  list: (postModel: PostModel<IMaterialTypeGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IMaterialTypeGridModel>>(
        endpoints.materialType.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IMaterialType>(`${endpoints.materialType.getById}/${Id}`),
  }),

  getMaterialTypeValues: () => ({
    queryKey: ["GetMaterialTypeValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.materialType.getMaterialTypeValues),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () =>
      api.get<materialTypeView>(`${endpoints.materialType.view}/${Id}`),
  }),
});
